import { render, staticRenderFns } from "./VideoFromURLEditor.vue?vue&type=template&id=a279390e&"
import script from "./VideoFromURLEditor.vue?vue&type=script&lang=js&"
export * from "./VideoFromURLEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports